import { render, staticRenderFns } from "./EventRegistration.vue?vue&type=template&id=45860226&scoped=true&"
import script from "./EventRegistration.vue?vue&type=script&lang=js&"
export * from "./EventRegistration.vue?vue&type=script&lang=js&"
import style0 from "./EventRegistration.vue?vue&type=style&index=0&id=45860226&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45860226",
  null
  
)

export default component.exports